import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquarePlaceholder: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSquarePlaceholder"><Path d="M21 3H3V21H21V3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquarePlaceholder;
